const $ = require('jquery');

function assigning_responsible() {
    const params = new URLSearchParams(window.location.search);
    const responsibleId = $('#responsible_id');
    responsibleId.val(params.get('responsible_id'));
}

export { assigning_responsible };
